// Single source of truth for menu navigation links.
// Categories, subcategories and brands use path params on every marketplace;
// the remaining filter types still fall through to the shop query string.
export const buildNavLink = (type, uriParam) => {
  if (type === 'category') return `/category/${uriParam}`;
  if (type === 'brand') return `/brands/${uriParam}`;
  if (type === 'dispensary') return `/dispensary/${uriParam}`;
  return `/shop?${type}=${uriParam}`;
};
